//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: "check_room_record",
        data(){
            return{
                date:'',
                form_type:'',
                form_type_options:[],
                keyword: '',
                page: '1',
                id:this.$route.query.id,
                tabVal:this.$route.query.tabVal,
                listData: [],
                pullupDefaultConfig: {
                    content: '上拉加载更多',
                    pullUpHeight: 60,
                    height: 40,
                    autoRefresh: false,
                    downContent: '释放后加载',
                    upContent: '上拉加载更多',
                    loadingContent: '加载中...',
                    clsPrefix: 'xs-plugin-pullup-'
                },
                pulldownDefaultConfig: {
                    content: '下拉刷新',
                    height: 40,
                    autoRefresh: false,
                    downContent: '下拉刷新',
                    upContent: '释放后刷新',
                    loadingContent: '正在刷新...',
                    clsPrefix: 'xs-plugin-pulldown-'
                },
            }
        },
        methods:{
            // dateOnConfirm(value){
            //     this.date = value
            //     this.refresh()
            // },
            //获取表单查房列表
            apiFormList(){
                let that = this
                let params = {
                    token: this.$cookie.get('token')
                }
                Api.checkRoomApi.roundFormList(params).then ( res => {
                    if(res.errcode == 1){  
                        if(res.data.length){
                            this.form_type_options = []
                            for(let item of res.data){
                                this.form_type_options.push({
                                    key:item.id,
                                    value:item.name
                                })
                            } 
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '年' + m + '月' + d + '日'
            },
            cInput(){
                this.keyword = ''
                this.refresh()
            },
            searchBtn(){
                this.$nextTick(() => {
                    this.$refs.scrollerBottom.reset({top: 0})
                    this.refresh()
                })
            },
            clearBtn(){
                let that = this
                that.keyword = ''
                that.form_type = ''
                that.date = ''
                this.refresh()
                this.$vux.toast.show({
                    type: 'success',
                    text: '已清空',
                })
            },
            // select_form_change(value){
            //     console.info('哇靠')
            //     this.form_type = value
            //     this.refresh()
            // },
            apiCheckRoomRecord(str){
                this.$vux.loading.show({
                    text: '正在加载'
                })
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id,
                    keyword: this.keyword,
                    date:this.date,
                    form_type:this.form_type,
                    page: this.page
                }
                // console.log(params)
                Api.checkRoomApi.roundAllList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.page++
                        this.$nextTick(() => {
                            this.$refs.scrollerBottom.reset()
                        })
                        if(res.data.list.length){
                            for(let item of res.data.list){
                                var createTime=this.formatDateTime(item.create_time)
                                if(createTime.indexOf("NaN")===-1){
                                     createTime=this.formatDateTime(item.create_time)
                                }else{
                                     createTime=''
                                }
                                let obj = {
                                    create_time:createTime,
                                    form_id: item.form_id,
                                    form_name: item.form_name,
                                    id: item.id,
                                    maternal_info_id: item.maternal_info_id,
                                    user_name: item.user_name
                                }
                                this.listData.push(obj)
                            } 
                            if(str == 'refresh'){
                                this.$refs.scrollerBottom.enablePullup()//启用上拉加载插件
                                this.$refs.scrollerBottom.donePulldown()//设置下拉刷新操作完成，在数据加载后执行
                            }else{
                                 this.$refs.scrollerBottom.donePullup()//设置上拉加载操作完成，在数据加载后执行
                            }
                            if( res.data.page.page == res.data.page.page_count){
                                this.$refs.scrollerBottom.disablePullup()// 禁用上拉加载，在没有更多数据时执行   
                            }
                        }else{
                            var arr = []
                            for (let i in res.data.list) {
                                arr.push(res.data.list[i]); 
                            }
                            for(let item of arr){
                                var createTime=this.formatDateTime(item.create_time)
                                if(createTime.indexOf("NaN")===-1){
                                     createTime=this.formatDateTime(item.create_time)
                                }else{
                                     createTime=''
                                }
                                let obj = {
                                    create_time:createTime,
                                    form_id: item.form_id,
                                    form_name: item.form_name,
                                    id: item.id,
                                    maternal_info_id: item.maternal_info_id,
                                    user_name: item.user_name
                                }
                                this.listData.push(obj)
                            } 
                            if(str == 'refresh'){
                                this.$refs.scrollerBottom.enablePullup()//启用上拉加载插件
                                this.$refs.scrollerBottom.donePulldown()//设置下拉刷新操作完成，在数据加载后执行
                            }else{
                                 this.$refs.scrollerBottom.donePullup()//设置上拉加载操作完成，在数据加载后执行
                            }
                            if( res.data.page.page == res.data.page.page_count){
                                this.$refs.scrollerBottom.disablePullup()// 禁用上拉加载，在没有更多数据时执行   
                            }
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //下拉刷新
            refresh() {
                this.listData = []
                this.page = '1'
                this.apiCheckRoomRecord('refresh')
            },
            //上拉加载
            loadMore() {
                this.apiCheckRoomRecord()
            },
        },
        created (){
            // this.$nextTick(() => {
            //     this.$refs.scrollerBottom.reset({top: 0})
            // })
            this.apiFormList()
            this.apiCheckRoomRecord()
        }
    }



// WEBPACK FOOTER //
// ./src/components/check_room_record.vue